import { ElephantPresetType } from '@aibees/elephant/types';
import { LabelGrouping } from '@aibees/elephant/types/label';
import { notificationIconMap } from '@aibees/elephant/utils';
import { useUpdatePresetMutationApi } from '@aibees/shared/api';
import { useBoolean, useNotify } from '@aibees/shared/hooks';
import { memo, useMemo } from 'react';
import {
  CreateActionBulkDialog,
  CreateActionBulkDialogData,
} from '../create-action-bulk-dialog';
import type { EditActionProps as Props } from './types';

export const SearchListEditAction = memo(
  ({ className, item, state }: Props) => {
    const api = useUpdatePresetMutationApi(item.id);
    const notify = useNotify();
    const grouping = useMemo(() => {
      return item.type === ElephantPresetType.COMPANY_SAVED_SEARCH
        ? LabelGrouping.COMPANY
        : LabelGrouping.PEOPLE;
    }, [item.type]);

    const loading = useBoolean();

    const handleClose = () => {
      state.onFalse();
    };

    const handleSubmit = (data: CreateActionBulkDialogData) => {
      const key = Date.now().toString();
      loading.onTrue();
      api
        .mutateAsync({
          ...item,
          ...data,
          value: {
            name: data.name,
            visibility: data.visibility,
          },
        })

        .then(() => {
          notify.complete(
            'Saved Name Updated',
            'Name changed successfully.',
            key,
            {
              icon: notificationIconMap.SaveSearch,
            }
          );
          loading.onToggle();
          handleClose();
        })
        .finally(loading.onFalse);
    };

    return (
      <CreateActionBulkDialog
        item={item}
        state={state}
        id={item.id}
        title="Edit Saved Name"
        icon="edit-outline"
        inputTitle="Saved Name:"
        isEdit
        defaultValue={item.name}
        loading={api.isLoading}
        grouping={grouping}
        onClick={handleSubmit}
      />
    );
  }
);

SearchListEditAction.displayName = 'EditAction';
